import * as React from 'react'
import classNames from 'classnames'

import Kicker from '../../00-Primitives/Kicker'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import ListItem from '../ListItem'
import style from './style.scss'

type Props = {
  className?: string
  headlineText: string
  textItems: string[]
  kickerText: string
}

function NumericList(props: Props) {
  const { className, kickerText, headlineText, textItems } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      <Kicker className={style.kicker}>{kickerText}</Kicker>
      <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      <ol className={classNames(style.orderedList)}>
        {textItems.map((text, index) => (
          <ListItem key={index} className={classNames(style.listItem)}>
            {text}
          </ListItem>
        ))}
      </ol>
    </div>
  )
}

export default NumericList
